// extracted by mini-css-extract-plugin
export default {"tupacGrid":"ao-z","tupacHeader":"bo-z","tupacHeader2":"co-z","tupacMenu":"do-z","tupacMenu2":"eo-z","tupacMain":"fo-z","tupacMain2":"go-z"};